<template>
  <div>
    <div class="cover py-4">
      <font-awesome-icon :icon="['fas', 'exclamation-triangle']" size="7x" />
      <h5 class="pt-2">Duplicated image,<br>please change me</h5>
    </div>
    <BaseImage
      :image="image" />
  </div>
</template>

<script>
export default {
  name: 'ImagePickerDuplicatedCover',
  props: {
    image: {
      type: [String, Object],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .cover {
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    object-fit: cover;
    height: 175px!important;
    width: 100%;
    max-width: 305px;
  }
</style>
